// extracted by mini-css-extract-plugin
export default {"main":"styles_main__1QKh-","graphic":"styles_graphic__opMp8"};